import { render } from "./PayloadDetail.vue?vue&type=template&id=5dd4ca12&scoped=true&ts=true"
import script from "./PayloadDetail.vue?vue&type=script&lang=ts"
export * from "./PayloadDetail.vue?vue&type=script&lang=ts"

import "./PayloadDetail.vue?vue&type=style&index=0&id=5dd4ca12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd4ca12"]])

export default __exports__